import { createFileRoute } from '@tanstack/react-router'
import { HttpStatusPage, httpStatusHead } from '@/components/http-status-page'
import type { HttpStatusData } from '@/components/http-status-page'

const data: HttpStatusData = {
  code: 200,
  name: 'OK',
  description:
    'The request succeeded. The server processed the request and returned the expected response body. This is the standard response for successful GET, POST, PUT, and PATCH requests.',
  causes: [
    'This is the normal, expected response. The server understood the request, processed it without errors, and returned the result.',
    'For GET requests, the response body contains the requested resource. For POST requests, it typically contains the result of the action.',
    'APIs return 200 for successful data retrieval, form submissions, and other operations that produce a response body.',
  ],
  fixes: [
    'No fix needed — 200 means everything worked. If you expected a different status code (e.g., 201 for resource creation), check your server-side logic.',
    'If your application treats 200 as an error, verify your response-parsing code. Ensure you are checking status codes correctly.',
    'For APIs, consider returning 201 for resource creation or 204 for actions with no response body instead of using 200 for everything.',
  ],
  monitoringTip:
    'Uptrack checks your endpoints and expects a 2xx response. If your endpoint stops returning 200 and starts returning 4xx or 5xx, Uptrack detects the change within 30 seconds and alerts you once several locations confirm it.',
}

export const Route = createFileRoute('/_site/http/200')({
  component: () => <HttpStatusPage data={data} />,
  head: () => httpStatusHead(data),
})
